import * as React from 'react';

import { cn } from '@/lib/utils';

export type BubbleTail = 'start' | 'end' | 'none';

export interface BubbleProps extends React.HTMLAttributes<HTMLDivElement> {
  tail?: BubbleTail;
}

const Bubble = React.forwardRef<HTMLDivElement, BubbleProps>(
  ({ className, tail = 'none', ...props }, ref) => (
    <div
      ref={ref}
      data-slot="bubble"
      data-tail={tail}
      className={cn(
        'w-fit max-w-full rounded-lg px-3 py-2 text-sm',
        tail === 'start' && 'rounded-bl-sm',
        tail === 'end' && 'rounded-br-sm',
        className,
      )}
      {...props}
    />
  ),
);
Bubble.displayName = 'Bubble';

const BubbleContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="bubble-content"
      className={cn('whitespace-pre-wrap break-words', className)}
      {...props}
    />
  ),
);
BubbleContent.displayName = 'BubbleContent';

export { Bubble, BubbleContent };
